import { render, staticRenderFns } from "./web-editor.vue?vue&type=template&id=f6bba08a&scoped=true"
import script from "./web-editor.vue?vue&type=script&lang=js"
export * from "./web-editor.vue?vue&type=script&lang=js"
import style0 from "./web-editor.vue?vue&type=style&index=0&id=f6bba08a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6bba08a",
  null
  
)

export default component.exports